import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import * as $ from "jquery";
import { CentralService } from "../servicios/central.service";
import {
  faSignInAlt,
  faKey,
  faEuroSign,
  faTractor,
  faMoneyBill,
  faFileInvoice,
  faUndo,
  faFileAlt,
  faGripLinesVertical,
} from "@fortawesome/free-solid-svg-icons";
import { AvisosComponent } from "../avisos/avisos.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject, Subscription } from "rxjs";
import { Router } from "@angular/router";
import * as XLSX from "xlsx";

@Component({
  selector: "app-adminLisPiensos",
  templateUrl: "./adminLisPiensos.component.html",
  styleUrls: ["./adminLisPiensos.component.css"],
})
export class AdminLisPiensosComponent implements OnInit, OnDestroy {
  dtOptions: any;
  dtTrigger: Subject<any> = new Subject();
  datosTabla: any = [{}];
  usuarioActual: any;

  icoEntr = faSignInAlt;
  icoKey = faKey;
  icoEur = faEuroSign;
  icoTra = faTractor;
  icoMny = faMoneyBill;
  icoInv = faFileInvoice;
  icoRet = faUndo;
  icoFac = faFileAlt;
  fecdia: string;
  nomusu: string;
  menu: any;
  iconos = [
    this.icoKey,
    this.icoEur,
    this.icoTra,
    this.icoMny,
    this.icoInv,
    this.icoFac,
  ];

  agrupado: any[] = [];
  resul: boolean;
  codigo: number;

  modoLis = 0;
  prifec: string;
  ultfec: string;
  filtroCliente: string = "";

  primerafecha: string;
  ultimafecha: string;
  piensos: any[] = [];
  marcasTipos: any[] = [];
  tablaPivotada: any[] = [];
  clientes: any[] = [];
  clienteSeleccionado: any = 0;

  modoBorrar = false;
  private piensosSubscription: Subscription | null = null;

  constructor(
    private srvCentral: CentralService,
    private modalService: NgbModal,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.fecdia = Date().toLocaleString();
    this.nomusu = this.srvCentral.datosIden.UsuNom;

    if (this.srvCentral.datosIden.UsuUsu !== "") {
      const k = this.srvCentral.listaMnu.length;
      this.menu = [];
      for (let i = 0; i < k; i++) {
        this.menu.push({
          nombre: this.srvCentral.listaMnu[i].nombre,
          ruta: this.srvCentral.listaMnu[i].ruta,
          icono: this.iconos[this.srvCentral.listaMnu[i].ico],
        });
      }
    }

    this.modoLis = this.srvCentral.EntModoLis;
    this.prifec = this.srvCentral.fechaCadena(this.srvCentral.gnPriDia);
    this.ultfec = this.srvCentral.fechaCadena(this.srvCentral.gnUltDia);

    this.usuarioActual = localStorage.getItem("usuarioActual");
    this.codigo = JSON.parse(this.usuarioActual || "{}").codUsu;

    this.srvCentral.consulPiensos("@").subscribe((datos) => {
      const agrupado: any[] = [];

      datos.forEach((d: any) => {
        let marca = agrupado.find((m) => m.ttcodmar === d.ttcodmar);
        if (!marca) {
          marca = {
            ttcodmar: d.ttcodmar,
            ttdesmar: d.ttdesmar,
            tipos: [],
          };
          agrupado.push(marca);
        }
        marca.tipos.push({
          ttcodtip: d.ttcodtip,
          ttdestip: d.ttdestip,
        });
      });

      this.marcasTipos = agrupado;
    });

    this.srvCentral.listClientes().subscribe({
      next: (res) => {
        if (!res || res.length === 0) {
          this.clientes = [
            { ttSocio: 0, ttNombr: "No hay clientes", ttEsSocio: "" },
          ];
        } else {
          this.clientes = [
            { ttSocio: 0, ttNombr: "Todos", ttEsSocio: "" },
            ...res,
          ];
        }
      },
      error: (err) => {
        console.error("Error al cargar clientes:", err);
        this.clientes = [
          { ttSocio: 0, ttNombr: "Error en la consulta", ttEsSocio: "" },
        ];
      },
    });
  }

  editarCantidades(fila: any) {
    fila.editandoCantidades = true;
  }

  cancelarEdicion(fila: any) {
    fila.editandoCantidades = false;
    // opcional: recargar fila para descartar cambios
    this.transformarPiensosParaTabla();
  }

  guardarCantidades(fila: any) {
    // preparar líneas para enviar al backend
    const lineasActualizar = fila.lineas.map((linea: any) => {
      const colKey = `${
        this.marcasTipos.find((m) => m.ttcodmar === linea.ttMarca)?.ttdesmar
      } ${
        this.marcasTipos
          .find((m) => m.ttcodmar === linea.ttMarca)
          ?.tipos.find((t) => t.ttcodtip === linea.ttTipo)?.ttdestip
      }`;
      return {
        ...linea,
        ttCanti: fila[colKey], // tomar el valor actualizado
      };
    });

    this.srvCentral.entregaPiensos(1, lineasActualizar).subscribe({
      next: (resp) => {
        this.mostrarAviso("Cantidades actualizadas correctamente");
        fila.editandoCantidades = false;
        // opcional: recargar tabla
        this.cargarPiensos();
      },
      error: (err) => {
        console.error("Error al actualizar cantidades:", err);
        this.mostrarAviso("Error al guardar las cantidades");
      },
    });
  }
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  persiana() {
    $("#wrapper").toggleClass("toggled");
  }

  cargarPiensos(): void {
    const fechaDesde = this.formatearFecha(this.primerafecha);
    const fechaHasta = this.formatearFecha(this.ultimafecha);

    if (this.piensosSubscription) {
      this.piensosSubscription.unsubscribe();
    }
    //console.log("Cliente seleccionado:", this.clienteSeleccionado);
    if (!this.clienteSeleccionado || this.clienteSeleccionado == 0) {
      //console.log(this.clienteSeleccionado, " ha entrado en el if");
      this.piensosSubscription = this.srvCentral
        .listarPiensos(fechaDesde, fechaHasta, 0)
        .subscribe({
          next: (data) => {
            this.piensos = data || [];
            this.transformarPiensosParaTabla();
          },
          error: (err) => {
            console.error("Error al cargar piensos:", err);
            this.mostrarAviso("Error al cargar los datos de piensos.");
            this.tablaPivotada = [];
          },
        });
    } else {
      this.piensosSubscription = this.srvCentral
        .listarPiensos(fechaDesde, fechaHasta, 0, this.clienteSeleccionado)
        .subscribe({
          next: (data) => {
            this.piensos = data || [];
            this.transformarPiensosParaTabla();
          },
          error: (err) => {
            console.error("Error al cargar piensos:", err);
            this.mostrarAviso("Error al cargar los datos de piensos.");
            this.tablaPivotada = [];
          },
        });
    }
  }

  private mostrarAviso(mensaje: string, tipo: number = 0): void {
    const modalRef = this.modalService.open(AvisosComponent);
    modalRef.componentInstance.datAviso = {
      tip: tipo, // 0=azul, 1=amarillo, 2=rojo
      tit: tipo === 0 ? "Información" : tipo === 1 ? "Aviso" : "Error",
      tex: mensaje,
      btsi: "Aceptar",
      btno: "",
      btcan: "",
    };
  }

  formatearFecha(fecha: string): string {
    if (!fecha) return "";
    const [year, month, day] = fecha.split("-");
    return `${day}-${month}-${year}`;
  }

  transformarPiensosParaTabla(): void {
    if (
      !this.piensos ||
      this.piensos.length === 0 ||
      this.piensos[0].ttClave === 0
    ) {
      this.tablaPivotada = [];
      return;
    }

    const grupos = new Map<string, any>();

    this.piensos.forEach((item) => {
      const clave = `${item.ttFecha}-${item.ttSocio}-${item.ttExplo}-${item.ttForma}`;

      if (!grupos.has(clave)) {
        const nuevaFila = {
          ttFecha: item.ttFecha,
          ttSocio: item.ttSocio,
          ttNombr: item.ttNombr,
          ttExplo: item.ttExplo,
          ttForma: item.ttForma,
          //
          ttPedido: item.ttPedido,
          ttServido: item.ttServido,
          lineas: [],
          ...this.inicializarCeldas(),
        };
        grupos.set(clave, nuevaFila);
      }

      const fila = grupos.get(clave);

      fila.lineas.push({
        ttSocio: item.ttSocio,
        ttFecha: item.ttFecha,
        ttExplo: item.ttExplo,
        ttMarca: item.ttMarca,
        ttTipo: item.ttTipo,
        ttCanti: item.ttCanti,
        ttForma: item.ttForma,
        ttOrden: item.ttOrden,
        ttPedido: item.ttPedido,
        ttServido: item.ttServido,
      });
      const combo = `${item.ttDesMc} ${item.ttDesTp}`.trim();

      for (const marca of this.marcasTipos) {
        for (const tipo of marca.tipos) {
          const colKey = `${marca.ttdesmar} ${tipo.ttdestip}`;
          if (colKey === combo) {
            fila[colKey] = item.ttCanti || 0;
            break;
          }
        }
      }
    });

    this.tablaPivotada = Array.from(grupos.values());
  }

  inicializarCeldas(): { [key: string]: number } {
    const celdas: { [key: string]: number } = {};
    for (const marca of this.marcasTipos) {
      for (const tipo of marca.tipos) {
        const colKey = `${marca.ttdesmar} ${tipo.ttdestip}`;
        celdas[colKey] = 0;
      }
    }
    return celdas;
  }

  obtenerCantidad(fila: any, marca: any, tipo: any): number {
    const clave = `${marca.ttdesmar} ${tipo.ttdestip}`;
    return fila[clave] || 0;
  }
  exportarAExcel(): void {
    if (this.tablaPivotada.length === 0) return;

    const filaMarcas: string[] = [
      "FECHA",
      "NOMBRE",
      "FINCA",
      "FORMATO",
      "PEDIDO",
      "SERVIDO",
    ];
    const filaTipos: string[] = ["", "", "", "", "", ""];

    for (const marca of this.marcasTipos) {
      for (let i = 0; i < marca.tipos.length; i++) {
        filaMarcas.push(marca.ttdesmar);
      }
      for (const tipo of marca.tipos) {
        filaTipos.push(tipo.ttdestip);
      }
    }

    const filasDatos = this.tablaPivotada.map((fila) => [
      fila.ttFecha,
      fila.ttNombr,
      fila.ttExplo,
      fila.ttForma === 0 ? "Envasado" : "Granel",
      fila.ttPedido === 1 ? "Sí" : "No",
      fila.ttServido === 1 ? "Sí" : "No",
      ...this.marcasTipos
        .map((marca) =>
          marca.tipos.map(
            (tipo) => fila[`${marca.ttdesmar} ${tipo.ttdestip}`] || 0,
          ),
        )
        .reduce((acc, val) => acc.concat(val), []),
    ]);

    const wsData = [filaMarcas, filaTipos, ...filasDatos];
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    const colWidths = wsData[0].map(() => ({ wch: 12 }));
    ws["!cols"] = colWidths;

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Piensos");

    const fecha = new Date().toISOString().slice(0, 10);
    XLSX.writeFile(wb, `piensos_${fecha}.xlsx`);
  }
  /*
  actualizarCampo(fila: any, campo: "ttPedido" | "ttServido"): void {
    fila[campo] = fila[campo] ? 1 : 0;
    //console.log("Actualizando campo:", campo, "en grupo:", fila);

    if (!fila.lineas || fila.lineas.length === 0) {
      console.warn("No hay líneas asociadas a la fila para actualizar.");
      return;
    }

    const lineasActualizar = fila.lineas.map((linea: any) => ({
      ...linea,
      ttPedido: fila.ttPedido,
      ttServido: fila.ttServido,
    }));

    //console.log("Enviando al backend (modo=1):", lineasActualizar);

    this.srvCentral.entregaPiensos(1, lineasActualizar).subscribe({
      next: (resp) => {
        //console.log("Actualización correcta:", resp);
        this.mostrarAviso("Entrega actualizada correctamente");
      },
      error: (err) => {
        console.error("Error actualizando grupo de líneas:", err);
        this.mostrarAviso("Error guardando el cambio de pedido/servido.");
      },
    });
  }
*/

  /*
  actualizarCampo(
    fila: any,
    campo: "ttPedido" | "ttServido" | "marca" | "cantidad",
  ): void {
    const valor = fila[campo];

    const lineasActualizar = fila.lineas.map((linea: any) => ({
      ...linea,
      marca: linea.marca,
      tipo: linea.tipo,
      cantidad: linea.cantidad,
      pedido: linea.pedido,
      servido: linea.servido,
    }));

    this.srvCentral.entregaPiensos(1, lineasActualizar).subscribe({
      next: (resp) => {
        if (!resp.resultado) {
          console.error("Error al actualizar:", resp);
        }
      },
      error: (err) => console.error("Error en la llamada:", err),
    });
  }
*/
  actualizarCampo(
    fila: any,
    campo: "ttPedido" | "ttServido" | "ttMarca" | "ttCanti",
  ): void {
    // Normalizar boolean a 0/1 si es checkbox
    if (campo === "ttPedido" || campo === "ttServido") {
      fila[campo] = fila[campo] ? 1 : 0;
    }

    const lineasActualizar = fila.lineas.map((linea: any) => {
      const marca = this.marcasTipos.find(
        (m: any) => m.ttcodmar === linea.ttMarca,
      );
      const tipo = marca?.tipos.find((t: any) => t.ttcodtip === linea.ttTipo);
      const colKey = `${marca?.ttdesmar} ${tipo?.ttdestip}`;

      return {
        ttSocio: linea.ttSocio,
        ttFecha: linea.ttFecha,
        ttOrden: linea.ttOrden,
        ttExplo: linea.ttExplo,
        ttMarca: linea.ttMarca,
        ttTipo: linea.ttTipo,
        ttForma: linea.ttForma,
        ttPedido: fila.ttPedido ? 1 : 0, // siempre normalizado
        ttServido: fila.ttServido ? 1 : 0,
        ttCanti: fila[colKey] ?? linea.ttCanti, // valor actualizado del input si existe
      };
    });

    this.srvCentral.entregaPiensos(1, lineasActualizar).subscribe({
      next: (resp) => {
        const hayError = resp.some(
          (r: any) => r.error !== "" || r.output?.oErrMsg === "ERROR",
        );
        if (hayError) {
          console.error("Error en alguna línea:", resp);
          this.mostrarAviso("Error al guardar alguna línea.");
        } else {
          this.mostrarAviso("Actualizado correctamente");
        }
      },
      error: (err) => {
        console.error("Error HTTP:", err);
        this.mostrarAviso("Error al guardar el cambio.");
      },
    });
  }
  activarBorrado(): void {
    this.modoBorrar = !this.modoBorrar;
  }

  borrarFila(fila: any): void {
    if (!fila || !fila.lineas || fila.lineas.length === 0) return;

    const confirmado = confirm(
      `¿Seguro que deseas borrar las ${fila.lineas.length} líneas de ${fila.ttNombr} (${fila.ttFecha})?`,
    );
    if (!confirmado) return;

    this.srvCentral.entregaPiensos(2, fila.lineas).subscribe({
      next: () => {
        this.mostrarAviso("Líneas borradas correctamente.");
        this.cargarPiensos();
      },
      error: () => this.mostrarAviso("Error al borrar las líneas."),
    });
  }
}
